import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedSportsRooms from './viewRelatedSportsRooms';
import { OPERATING_SYSTEMS } from '../utils/operatingSystemUtils';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedConfigThirdParty from './viewRelatedConfigThirdParty';
import viewRelatedCountries  from './viewRelatedCountries';
export default {
  title: 'General',
  attributeName: 'infoPages',
  helpText: '',
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the config',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'entry_points',
      label: 'Entry Point',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      blockItemRemove: true,
      maxElements: 1,
      configFile: viewRelatedSportsRooms,
      default: [],
      helpText: 'Define the main room to be shown as main room.',
      width: '30rem',
    },
    {
      attributeName: 'availableProviders',
      label: 'Available Provider',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedConfigThirdParty,
      default: [],
      helpText: 'Select the authentication provider required to access this MainHub.',
      exactWidth: '10rem',
    },
    {
      attributeName: 'available_in_countries',
      label: 'Available Countries',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedCountries,
      default: [],
      helpText: 'Select the countries where this configuration will be available.',
      exactWidth: '10rem',
    },
    {
      attributeName: 'operatingSystem',
      label: 'Operating System ',
      helpText: 'Specifies the operating system of this config.',
      default: '(Empty)',
      canEdit: false,
      canCreate: true,
      canFilter: false,
      emptyValue: true,
      type: FormInputTypes.SELECT,
      disabledWhenEdit: true,
      options: [
        { name: 'Oculus Quest', value: OPERATING_SYSTEMS.oculusQuest.key },
        { name: 'Android XR VR', value: OPERATING_SYSTEMS.androidXR.key },
        { name: 'Apple Vision PRO', value: OPERATING_SYSTEMS.visionOS.key },
      ],
    },
  ],
};
